<template>
  <div id="app" ref="app">
    <PCNavbar selectIndex="1"/>
    <MobileNavBar :currentActive="0"/>
    <div class="null-class"></div>
    <router-view></router-view>
    <BackTop />
    <CallMe />
    <!-- <img class="lxwm-img" @click="openQiyu" src="./assets/jsht/lxwm.png" alt=""> -->
    <!-- <a target="_blank" href="https://wxhtsyyyglyxgs.qiyukf.com/client?k=f77354484c715177e5aa958bb44cb313&wp=1&robotShuntSwitch=0&shuntId=0&templateId=8128271&language=zh-cn">
      <img class="lxwm-img" src="./assets/jsht/lxwm.png" alt="">
    </a> -->
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CallMe from '@/components/callme/index'
import YSF from '@neysf/qiyu-web-sdk';
export default {
  name: 'App',
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe
  },
  watch: {
    $route() {
    },
  },
  mounted(){
    // YSF.init('044865c94981c048609d5c94c1ae9c6d', {
    //     templateId: 123, // templateId表示自定义会话邀请的模板标识
    //     // shuntId: 123, // shuntId表示访客选择多入口分流模版id
    //     sessionInvite: false, // sessionInvite表示是否开启会话邀请设置
    //     hidden: 1 // hidden表示是否隐藏访客端默认入口
    // }).then(ysf => {
    //     // ysf('open');
    // }).catch(error => {
    //     console.log('sdk加载失败---', error);
    // });
  },
  methods:{
    // openQiyu(){
    //     ysf('open');

    // }
  }
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}
#app{
  display: flex;
  flex-direction: column;
  padding-top: 80px;
  width: 100%;
  overflow-x: hidden;
  font-size: 16px !important;
  // font-weight: 200;
}
@import url('./assets/css/icon.css');
.detail-info{
  min-height: calc(100vh - 80px - 250px - 360px) !important;
}
.lxwm-img{
  width: 80px;
  height: 80px;
  position: fixed;
  right: 0;
  bottom: 300px;
  z-index: 1000;
  cursor: pointer;
}
  .menu_item_index{
    font-weight: 600;
    font-size: 16px;
  }
  .el-submenu__title{
    font-size: 16px !important;    
  }
  .el-menu-item{
    font-size: 16px !important;    
  }

.el-button,
.el-input,
.el-select,
.el-table,
.el-form-item__label,
.el-menu-item,
.el-tabs__item {
  font-size: 16px !important;
}
.el-table{
  font-weight: 400 !important;
  color: #000000 !important;
}
.detail-info-title{
  font-weight: bolder;
  font-size: 18px !important;
  .el-breadcrumb{
  font-size: 18px !important;

  }
  .el-breadcrumb__inner{
    font-weight: bold !important;
  }
}
</style>
